import { Directive, Input } from '@angular/core';

@Directive({
  selector: '[min-width]',
  standalone: true,
  host: {
    '[style.min-width]': 'minWidth',
  }
})
export class MinWidthDirective {

  @Input({ alias: 'min-width' }) minWidth: string;
}
